import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-favorite-toggle',
  standalone: true,
  imports: [NgClass],
  template: `
    <div class="favorite-cell">
      <i
        class="fa-star favorite-icon"
        [ngClass]="isFavorite ? 'fa-solid' : 'fa-regular'"
        (click)="toggle($event)"
      ></i>
    </div>
  `,
  styles: [
    `
      /* The host is inline and content-sized by default, so the star would sit at
         the left of the cell instead of centering. */
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
      .favorite-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
      .favorite-icon {
        cursor: pointer;
        font-size: 16px;
        color: darkkhaki;
      }
    `,
  ],
})
export class FavoriteToggleComponent implements ICellRendererAngularComp {
  isFavorite = false;
  private rowData: any;

  constructor(private sharedService: SharedService) {}

  agInit(params: ICellRendererParams): void {
    this.rowData = params.data;
    this.sharedService.loadFavoriteUpcs().subscribe(() => {
      this.isFavorite = this.sharedService.isFavorite(this.rowData?.upc);
    });
  }

  refresh(): boolean {
    return false;
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    const upc = this.rowData?.upc;
    if (!upc) return;

    const nextIsFavorite = !this.isFavorite;
    this.isFavorite = nextIsFavorite; // optimistic

    const request$ = nextIsFavorite
      ? this.sharedService.addFavorite({
          upc,
          item_number: this.rowData?.item_number,
          manufacturer: this.rowData?.manufacturer,
          description: this.rowData?.desc1,
          mfg_part_number: this.rowData?.mfg_part_number,
        })
      : this.sharedService.removeFavorite(upc);

    request$.subscribe({
      next: () => {
        this.sharedService.raiseSuccessToast(
          nextIsFavorite ? 'Added to Favorites' : 'Removed from Favorites',
        );
      },
      error: () => {
        this.isFavorite = !nextIsFavorite; // revert on failure
        this.sharedService.raiseErrorToast('Failed to update favorites');
      },
    });
  }
}
